import { render, staticRenderFns } from "./SplitterPanel.vue?vue&type=template&id=5f690616"
import script from "./SplitterPanel.vue?vue&type=script&lang=js"
export * from "./SplitterPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports